import { UNINTERESTING_KEYWORDS } from './constants'

/**
 * Check if a title looks uninteresting based on keywords
 */
export function titleLooksUninteresting(title: string | null | undefined): boolean {
  if (!title) return true
  const t = title.toLowerCase()
  return UNINTERESTING_KEYWORDS.some((word) => t.includes(word))
}

/**
 * Trim text to a sentence boundary within maxChars
 */
export function trimToSentence(text: string | null | undefined, maxChars: number): string {
  const t = (text || '').replace(/\s+/g, ' ').trim()
  if (!t) return ''
  if (t.length <= maxChars) return t

  const cut = t.slice(0, maxChars)
  const m = cut.match(/(.+?[\.!?])\s+[^\.!?]*$/)
  if (m && m[1] && m[1].length > 160) return m[1].trim()

  const idx = Math.max(
    cut.lastIndexOf('. '),
    cut.lastIndexOf('! '),
    cut.lastIndexOf('? ')
  )
  if (idx > 160) return cut.slice(0, idx + 1).trim()

  return cut.trim()
}

/**
 * Get side phrase for directional description
 */
export function sidePhrase(
  deltaAbs: number,
  deltaSigned: number,
  lang: string
): string {
  const side =
    deltaSigned > 0
      ? lang === 'nl'
        ? 'rechts'
        : 'to your right'
      : lang === 'nl'
      ? 'links'
      : 'to your left'

  const frontish = deltaAbs <= 20
  const behindish = deltaAbs >= 140

  if (lang !== 'nl') {
    if (frontish) return 'ahead'
    if (behindish) return 'behind you'
    return side
  }

  if (frontish) return 'voor u'
  if (behindish) return 'achter u'
  return `${side} voor u`
}

/**
 * Get Wikipedia domain for a language code
 */
export function wikiDomainFor(lang: string): string {
  return `${lang}.wikipedia.org`
}

/**
 * Get chosen language from browser or forced language
 */
export function chosenLang(forcedLang: string | null = null): string {
  if (forcedLang) return forcedLang
  const nav = (navigator.language || 'en').slice(0, 2).toLowerCase()
  const supported = ['nl', 'en', 'de', 'fr', 'es', 'it', 'pt', 'sv', 'da', 'no']
  return supported.includes(nav) ? nav : 'en'
}
